import { TableItemStatus, TableItemStatusControl } from "ui";

import { OFFERS_STATUSES_LIST } from "../../constants";
import { isWithinRange } from "../../helpers";
import { MainInformationProps } from "./OfferStatus.types";

const OfferStatus = ({
  offerId,
  offerStatus,
  rowIndex,
  openedItemStatusesIndex,
  setOpenedItemStatusesIndex,
  onUpdateStatus,
  fromDate,
  toDate
}: MainInformationProps) => {
  const handleStatusUpdate = (status: string, id: string) => {
    if (openedItemStatusesIndex !== null) {
      onUpdateStatus({
        id,
        body: { status }
      });
    }
  };

  const statusesList = OFFERS_STATUSES_LIST.map((orStatus) => ({
    ...orStatus,
    onClick: () => handleStatusUpdate(orStatus.value, offerId)
  }));

  const isStatusChangeable = isWithinRange(fromDate, toDate);

  return (
    <>
      {isStatusChangeable ? (
        <TableItemStatusControl
          rowIndex={rowIndex}
          activeStatusIndex={OFFERS_STATUSES_LIST.findIndex(
            (status) => status?.value === offerStatus
          )}
          openedItemStatusesIndex={openedItemStatusesIndex}
          setOpenedItemStatusesIndex={setOpenedItemStatusesIndex}
          statusesList={statusesList}
        />
      ) : (
        <TableItemStatus
          activeStatusIndex={OFFERS_STATUSES_LIST.findIndex(
            (status) => status?.value === offerStatus
          )}
          statusesList={OFFERS_STATUSES_LIST}
        />
      )}
    </>
  );
};

export default OfferStatus;
